import SpacedTexts from "Global/Components/CommonComponents/SpacedTexts/SpacedTexts";
import React from "react";
import { ArabicToPersian } from "utils/ConvertToPersianTextFromArabic";
import { Price3DigitSplitter } from "utils/Price3DigitSplitter";
import { dictionary } from "../Contract_Details/dictionary/dictionary";

const Contract_Header_Info = ({ details, setReceptions }) => {
  const { freezeType, startDate, stopDate, owePrice } = dictionary();
  return (
    <React.Fragment>
      <div
        style={{ all: "inherit", padding: 0 }}
        onClick={() => {
          setReceptions([]);
        }}
      >
        <SpacedTexts
          firstText={ArabicToPersian(details?.NoeFreezName)}
          secondText={freezeType}
        />
        <SpacedTexts firstText={details?.TarikhShoro} secondText={startDate} />
        <SpacedTexts firstText={details?.AkharinTamdid} secondText={stopDate} />
        <SpacedTexts
          firstText={Price3DigitSplitter(details?.MablaghBedehkari)}
          secondText={owePrice}
        />
      </div>
    </React.Fragment>
  );
};

export default Contract_Header_Info;
